import React from "react";
import EnergyAssetsCard from "./EnergyAssetsCard";

const SolarPower = ({ energyAssetsData }) => {
  const SolarPowerPlants = energyAssetsData.filter(
    (plant) => plant.field_category_page_assets === "Solar Power"
  );

  // Check if there are no hydro power plants
  if (SolarPowerPlants.length === 0) {
    return <div>No Solar power plants available</div>;
  }

  return (
    <div className="hydro-power-box1b aos-init aos-animate">
      <ul>
        {SolarPowerPlants.map((item, index) => (
          <EnergyAssetsCard plantData={item} key={index} />
        ))}
      </ul>
    </div>
  );
};

export default SolarPower;
